import { View } from "react-native";
import { memo } from "react";
import StyledText from "../../../common/ui/styled-text";
import { LucideIcon } from "lucide-react-native";

interface SettingsItemProps {
  title?: string;
  description?: string;
  icon?: LucideIcon;
  leftItem?: React.ReactNode;
  children?: React.ReactNode;
  required?: boolean;
  disabled?: boolean;
  titleComponent?: React.ReactNode;
  descriptionComponent?: React.ReactNode;
  withFlex?: boolean;
  className?: string;
}

const SettingsItem = memo(function SettingsItem({
  title,
  description,
  icon: Icon,
  leftItem,
  children,
  required = false,
  disabled = false,
  titleComponent,
  descriptionComponent,
  withFlex = false,
  className,
}: SettingsItemProps) {
  return (
    <View className={`${withFlex ? "flex-1" : ""} ${className}`}>
      <View
        className={`flex-row items-center justify-between ${
          disabled ? "cursor-not-allowed opacity-50" : ""
        }`}
        pointerEvents={disabled ? "none" : "auto"}
      >
        <View className="flex-1 mr-4 gap-0.5">
          {titleComponent ? (
            titleComponent
          ) : (
            <View className="flex-row items-center gap-2">
              {Icon && (
                <Icon size={16} color={disabled ? "#6B7280" : "#374151"} />
              )}
              <StyledText
                className={`text-base font-medium ${
                  disabled ? "text-gray-500" : "text-gray-900"
                }`}
              >
                {title}
                {required && (
                  <StyledText
                    className={disabled ? "text-gray-500" : "text-red-500"}
                  >
                    {" "}
                    *
                  </StyledText>
                )}
              </StyledText>
            </View>
          )}
          {descriptionComponent
            ? descriptionComponent
            : description && (
                <StyledText className="text-sm text-gray-500">
                  {description}
                </StyledText>
              )}
        </View>
        {!!leftItem && leftItem}
      </View>
      {!!children && (
        <View
          className={`${Icon ? "sm:ml-0" : ""} pt-4 
          ${withFlex ? "flex-1" : ""}`}
          pointerEvents={disabled ? "none" : "auto"}
        >
          {children}
        </View>
      )}
    </View>
  );
});

export default SettingsItem;
